<div class="profile-header">
  <div class="avatar-container">
    @if (imageUrl() && !imageLoadFailed()) {
      <img
        class="avatar"
        [src]="imageUrl()"
        alt="Profile picture"
        (error)="onImageError()"
        (load)="onImageLoad()"
      />
    } @else {
      <div class="avatar avatar-placeholder">
        <span class="initials">{{ initials() }}</span>
      </div>
    }
  </div>

  <h2 class="display-name">{{ displayName() }}</h2>
  <p class="email">{{ email() }}</p>
</div>
